import { Section } from "./About";

const DOCS = {
  terms: {
    title: "Terms of Service",
    sections: [
      ["Acceptance", "By creating an account or purchasing from Raphanex Store you agree to these terms. If you do not agree, please do not use the service."],
      ["Accounts", "You are responsible for keeping your phone number and password secure and for all activity under your account. Provide accurate information when registering."],
      ["Digital products", "Products are licensed for your personal use unless a product states otherwise. You may not resell, redistribute or share access to purchased products."],
      ["Separate services", "Some services available to signed-in members are provided separately from the main store and may have additional terms displayed within that section."],
      ["Prohibited use", "You may not attempt to bypass payments, interfere with the platform, or access other users' accounts or administrative functions."],
      ["Termination", "We may suspend or disable accounts that violate these terms."],
      ["Liability", "The service is provided as-is. To the extent permitted by Ghanaian law, our liability is limited to the amount you paid for the relevant product."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["What we collect", "Your name, phone number, optional email, purchase history and payment references. We do not collect or store card numbers, CVVs or Mobile Money PINs."],
      ["How we use it", "To operate your account, deliver purchases, verify payments, prevent fraud and provide support."],
      ["Payment processing", "Payments are processed by theteller (PaySwitch). Their handling of your payment data is governed by their own privacy policy."],
      ["Security", "Passwords are stored as one-way hashes. Sessions use secure, HTTP-only cookies."],
      ["Your rights", "You can update your profile at any time and contact us to request access to or deletion of your data, subject to legal record-keeping obligations."],
    ],
  },
  refund: {
    title: "Refund Policy",
    sections: [
      ["Digital goods", "Digital products are delivered instantly, so purchases are generally final once access has been granted."],
      ["Eligible refunds", "You may request a refund if you were charged but did not receive access, were charged twice for the same item, or the product is materially different from its description."],
      ["How to request", "Contact support within 7 days of purchase with your payment reference. Approved refunds are returned via the original payment channel."],
      ["Failed or cancelled payments", "If a payment fails or is cancelled you are not charged. If funds were deducted, they are typically reversed by your provider."],
    ],
  },
  payment: {
    title: "Payment Policy",
    sections: [
      ["Payment partner", "All payments are processed by theteller, a payment gateway operated by PaySwitch Ghana."],
      ["Currency", "All prices are in Ghana Cedis (GH₵)."],
      ["Accepted methods", "MTN Mobile Money, Telecel Cash, AT Money, Visa and Mastercard, subject to availability on theteller checkout."],
      ["Verification", "Every payment is verified server-to-server with theteller. Access is granted only after the payment reference, amount and status are confirmed."],
      ["References", "Each attempt receives a unique 12-digit payment reference. Keep it for support queries."],
      ["Duplicate protection", "You cannot be charged twice for a product you already own; repeated clicks reuse the same pending payment."],
    ],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc];
  return (
    <Section eyebrow="Legal" title={d.title} text={`Last updated ${new Date().toLocaleDateString("en-GB", { month: "long", year: "numeric" })}.`}>
      <div className="mt-12 max-w-3xl space-y-10" data-testid={`legal-${doc}`}>
        {d.sections.map(([h, t], i) => (
          <section key={h}>
            <h2 className="text-lg font-semibold text-white"><span className="mr-2 font-mono-rx text-sm text-emerald-400">{String(i + 1).padStart(2, "0")}</span>{h}</h2>
            <p className="mt-2 leading-relaxed text-slate-400">{t}</p>
          </section>
        ))}
      </div>
    </Section>
  );
}
